import {STORE_VERSION} from '../constants'

export function storeVersion(apiResponse) {
  return {
    type: STORE_VERSION,
    payload: {ltiApiVersion: apiResponse.version, apiVersion: apiResponse.api},
  }
}
